import { Avatar } from 'antd'
import { getNameSignature } from 'helper/utility'
import React from 'react'

interface CustomAvatarProps {
  src?: string
  size?: number
  name?: string
}

const CustomAvatar: React.FC<CustomAvatarProps> = ({
  src,
  size = 32,
  name = 'Name',
}) => {
  const bgs = ['#FFF1F3', '#F0EEFB', '#EEFCF9', '#F1FCFF', '#EAF1FF']
  const color = ['#FA7088', '#7F7DE4', '#9ECEC3', '#5E94AD', '#5D89DF']
  const index = Math.floor(Math.random() * bgs.length)
  return (
    <Avatar
      size={size}
      src={src}
      style={{
        backgroundColor: bgs[index],
        fontSize: '100%',
        color: color[index],
        fontWeight: 600,
      }}
    >
      {getNameSignature(name)}
    </Avatar>
  )
}

export default CustomAvatar
